import Cookies from "js-cookie";

const TokenKey = "Ai-Token";

const ExpiresInKey = "Ai-Expires-In";

export const openOrderPage = "Ai-Open-Order-Page";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1;
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time);
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey);
}

export function getOpenOrderPage() {
  let open =  Cookies.get(openOrderPage);
  return open == undefined ? '1' : open;
}

export function setOpenOrderPage(flag) {
  return Cookies.set(openOrderPage, flag);
}
